"use client";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { usePathname, useSearchParams } from "next/navigation";
import { createContext, useContext, useEffect, useMemo } from "react";

const AnalyticsContext = createContext<AnalyticsBrowser>(undefined!);

type Props = {
  writeKey: string;
  children: React.ReactNode;
};
export const AnalyticsProvider = ({ children, writeKey }: Props) => {
  const analytics = useMemo(
    () => AnalyticsBrowser.load({ writeKey }),
    [writeKey],
  );
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const PageTracker = () => {
  const analytics = useContext(AnalyticsContext);

  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    let newPageViewPath: string | undefined;

    if (analytics && pathname) {
      newPageViewPath =
        pathname + (searchParams ? searchParams.toString() : "");
      analytics.page({
        // url: newPageViewPath,
        referrer: document.referrer,
        path: newPageViewPath,
      });
    }
  }, [analytics, pathname, searchParams]);

  return <></>;
};

// Create an analytics hook that we can use with other components.
export const useAnalytics = () => {
  const result = useContext(AnalyticsContext);

  if (!result) {
    throw new Error("Context used outside of its Provider!");
  }
  return result;
};
